import { useUpdate } from '../../../../api/react-query';

export function useConfigEdit({ id, params }) {
  const { mutateAsync, isLoading: isEditing } = useUpdate({
    url: 'config/configs',
    id,
    params,
  });

  return {
    editConfig: mutateAsync,
    isEditing,
  };
}
